import React from 'react';
import CountUp from '../CountUp';
import Reveal from './Reveal';
import './styles.scss';

const stats = [
  { value: 11, prefix: '', suffix: '', label: 'Field tools · every plan' },
  { value: 39, prefix: '$', suffix: '', label: 'Per user / mo · CAD' },
  { value: 599, prefix: '$', suffix: '', label: 'Flat per project / mo' },
  { value: 90, prefix: '', suffix: '', label: 'Days free · no card' },
];

export default function StatsBand() {
  return (
    <section className="plh-stats" aria-label="ProjectLoop by the numbers">
      <div className="plh-stats__inner">
        {stats.map((stat, idx) => (
          <Reveal className="plh-stats__item" key={stat.label} delay={idx * 80}>
            <span className="plh-stats__num">
              <CountUp value={stat.value} prefix={stat.prefix} suffix={stat.suffix} duration={900} />
            </span>
            <span className="plh-stats__label plh-mono">{stat.label}</span>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
